module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/placeholder/placeholder-01-e2a4df16fa9e1dd04040f070967acb62.jpg";